import React, { useState, useEffect } from 'react';
import { Button, Form, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { getUserInitials, resolveAvatarSrc } from 'utils/avatar';
// import Select from 'react-select';

const AddPoll = ({ agenda, item, meetingId, getPolls }) => {
  const { user: authUser } = useSelector(x => x.auth);
  const url = process.env.REACT_APP_URL;

  const [showPollForm, setShowPollForm] = useState(false); // Toggle poll creation form
  // const [selectedPollEvent, setSelectedPollEvent] = useState(null); // Selected poll event
  const [selectedItems, setSelectedItems] = useState([]); // Selected agenda items
  const [agendaAvatars, setAgendaAvatars] = useState({})

  useEffect(() => {
    let mounted = true
    try {
      (agenda || []).forEach((itemAgenda) => {
        const key = String(itemAgenda.assignedUser?.tmAuthUserId || itemAgenda.assignedUser?.id || itemAgenda.assignedUser?._id || '').trim()
        if (!key) return
        const existing = resolveAvatarSrc(itemAgenda.assignedUser?.avatarUrl || itemAgenda.assignedUser?.avatar || '')
        if (existing) return
        if (agendaAvatars[key]) return

        (async () => {
          try {
            const resp = await fetch(`${url}/unified/${encodeURIComponent(key)}`)
            if (!mounted) return
            if (!resp.ok) return
            const payload = await resp.json().catch(() => null)
            const avatar = payload?.identity?.avatarUrl || payload?.identity?.avatar || null
            const src = avatar ? resolveAvatarSrc(avatar) : null
            if (src && mounted) setAgendaAvatars(prev => ({ ...prev, [key]: src }))
          } catch (_err) {
            // ignore
          }
        })()
      })
    } catch (_err) {
      // ignore
    }

    return () => { mounted = false }
  }, [agenda, agendaAvatars, url])

  const togglePollForm = () => setShowPollForm(!showPollForm);

  // console.log('item in AddPoll:', item);


  const handleSelectItem = (itemAgenda) => {
    const itemData = {
      agendaEventName: itemAgenda.agendaEvent.name,
      title: itemAgenda.item_title || itemAgenda.agendaEvent.name,
      agendaItemId: itemAgenda.agendaItemId,
      assignedUserId: itemAgenda.assignedUser?.id || null,
      assignedUserFirstName: itemAgenda.assignedUser?.firstName || 'TBA',
      assignedUserLastName: itemAgenda.assignedUser?.lastName || '',
      assignedUserAvatar: itemAgenda.assignedUser?.avatarUrl || itemAgenda.assignedUser?.avatar || '',
      meetingRoleName: itemAgenda.meetingRole?.name || 'N/A',
    };

    setSelectedItems((prevItems) =>
      prevItems.some((i) => i.agendaItemId === itemData.agendaItemId)
        ? prevItems.filter((i) => i.agendaItemId !== itemData.agendaItemId)
        : [...prevItems, itemData]
    );
  };

  const handleCreatePoll = async () => {
    if (selectedItems.length === 0) {
      toast.error('Please select at least one agenda item.', {
        position: 'bottom-left',
      });
      return;
    }

    const newPoll = {
      title: item?.agendaEvent.name,
      options: selectedItems.map((itemAgenda) => ({
        firstName: itemAgenda.assignedUserFirstName,
        lastName: itemAgenda.assignedUserLastName,
        userId: itemAgenda.assignedUserId,
        title: itemAgenda.title,
        votes: 0, // Initialize votes for each option
      })),
      meeting: meetingId,
      status: 'ready',
    };

    // console.log('Creating poll with data:', newPoll);

    try {
      const response = await fetch(`${url}/poll/${meetingId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authUser.token,
        },
        body: JSON.stringify(newPoll),
      });

      const raw = await response.text();
      let data = null;
      try {
        data = raw ? JSON.parse(raw) : null;
      } catch {
        data = null;
      }

      if (!response.ok) {
        throw new Error(data?.Error || data?.error || response.statusText || 'Failed to create poll.');
      }

      if (data?.status === 'ready') {
        getPolls(); // Fetch updated polls
        setSelectedItems([]); // Reset selected items
        setShowPollForm(false); // Hide the form
      } else {
        toast.error('Poll was created with an unexpected response.', { position: 'bottom-left' });
      }
    } catch (error) {
      console.error('Error creating poll:', error);
      toast.error(error.message || 'An error occurred while creating the poll.', { position: 'bottom-left' });
    }
  };

  return (
    <>
      <Button
        variant="success"
        onClick={togglePollForm}
        className="mb-3 w-100"
      >
        {showPollForm ? 'Cancel Poll Creation' : 'Create Poll ' + item.agendaEvent.name.substring(4, item.agendaEvent.name.length)}
      </Button>

      {showPollForm && (
        <Form className=''>
          <Form.Group controlId="agendaItems" className="mb-3">
            <Form.Label>Select Agenda Items</Form.Label>
            <Row>
              {agenda.map((itemAgenda) => (
                (() => {
                  const selected = selectedItems.some((i) => i.agendaItemId === itemAgenda.agendaItemId);
                  const avatarSrc = resolveAvatarSrc(itemAgenda.assignedUser?.avatarUrl || itemAgenda.assignedUser?.avatar || '')
                  const key = String(itemAgenda.assignedUser?.tmAuthUserId || itemAgenda.assignedUser?.id || itemAgenda.assignedUser?._id || '').trim()
                  const effectiveAvatar = avatarSrc || (key ? agendaAvatars[key] : null)
                  const userInitials = getUserInitials(itemAgenda.assignedUser, 'T');
                  return (
                    <Col key={itemAgenda.agendaItemId} xs={12} md={6} lg={4} className='mb-2'>
                      <Card
                        key={itemAgenda.agendaItemId}
                        onClick={() => handleSelectItem(itemAgenda)}
                        className='poll-option-card h-100'
                        style={{
                          cursor: 'pointer',
                          background: selected ? 'rgba(0, 65, 101, 0.26)' : 'rgba(128, 128, 128, 0.08)',
                          border: `1px solid ${selected ? 'rgba(13, 110, 253, 0.7)' : 'rgba(128, 128, 128, 0.35)'}`,
                          color: 'var(--foreground)',
                          borderRadius: 8
                        }}
                      >
                        <Card.Body className='d-flex align-items-center gap-3'>
                          {effectiveAvatar ? (
                            <img
                              src={effectiveAvatar}
                              alt='Poll option avatar'
                              style={{ width: 56, height: 56, borderRadius: '50%', objectFit: 'cover' }}
                            />
                          ) : (
                            <span
                              style={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                background: '#6c757d',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: 20
                              }}
                            >
                              {userInitials}
                            </span>
                          )}
                          <div className='text-start'>
                            <div className='fw-semibold'>
                              {itemAgenda.assignedUser?.firstName || 'TBA'} {itemAgenda.assignedUser?.lastName || ''}
                            </div>
                            <div style={{ fontSize: '0.85em', opacity: 0.9 }}>
                              {itemAgenda.meetingRole?.name || 'N/A'}
                            </div>
                            <div style={{ fontSize: '0.8em', opacity: 0.75 }}>
                              {itemAgenda.agendaEvent?.name || 'Agenda item'}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })()
              ))}
            </Row>
          </Form.Group>
          <Button
            variant="success"
            onClick={handleCreatePoll}
            className="w-100"
          >
            Create Poll
          </Button>
        </Form>
      )}
    </>
  );
};

export default AddPoll;
